<div class="alert"
    [class]="classes"
    [ngClass]="{
        bg_warning_light: tone=='warning',
        bg_primary_100: tone=='positive',
        with_icon: icon
    }"
    role="text">
    <mat-icon class="material-icons-outlined" *ngIf="icon">{{ icon }}</mat-icon>
    <span class="flex1" [innerHTML]="innerHTML | safeHtml" (click)="processLinks($event)"></span>
</div>